module.exports = __webpack_public_path__ + "img/no-design.afab1208.png";